module.exports = __webpack_public_path__ + "static/media/hackerNews.aa91c597.png";